module.exports = __webpack_public_path__ + "img/inventario.ecc29356.svg";